export type UiTheme = 'light' | 'dark';

export const UI_THEME: UiTheme =
  import.meta.env.VITE_UI_THEME === 'dark' ? 'dark' : 'light';

export const isDarkTheme = UI_THEME === 'dark';
export const quoteTone = isDarkTheme ? ('dark' as const) : ('light' as const);
export const footerVariant = isDarkTheme ? ('dark' as const) : ('light' as const);
